export class Product {
    Id_Product = 0;
    IsOwn = 0;
    IsFavorite = 0;
    IsXcluded = 0;
    Id_ParentRecipe = 0;
    ParentRecipeFullName = '';
    FullName = '';
    Description = '';
    ImagePath = '';
    Image = '';
    Id_CategoryProduct = 0;
    CategoryName = '';
    UnUsefullPart = 0;
    Density = 0;
    IsBulk = 0;
    PieceWeight = 0;
    Proteins = 0;
    Fats = 0;
    Carbohydrates = 0;
    CalorificValue = 0;
    Id_ProductAlternative = 0;
    CalculationWeight = 0;
    SortedBy = '';
}





// WEBPACK FOOTER //
// ./src/app/shared/models/product-model.ts